import {ProductModel} from '../../../store/ProductStore'
import {useCustomerStore, useGlobalStore, useRapidDeliveryStore} from '../../../store/hooks/useStore'
import {Nullable} from '../../../types/utils'
import {ItemPrices} from '../../../types/item-prices'
import {calculateItemPrice} from './calculateItemPrice'

export function useItemPrice(hit: Nullable<ProductModel>) {
  const {selectedPriceDayOffset, selectedRegion} = useGlobalStore()
  const {getApplicablePromotions} = useCustomerStore()
  const {isRapidPricingActive} = useRapidDeliveryStore()

  return calculateItemPrice({
    hit,
    selectedPriceDayOffset,
    selectedRegion,
    isRapidPricingActive,
    getApplicablePromotions
  })
}

export function useItemsPrices(hits: ProductModel[]): ItemPrices[] {
  const {selectedPriceDayOffset, selectedRegion} = useGlobalStore()
  const {getApplicablePromotions} = useCustomerStore()
  const {isRapidPricingActive} = useRapidDeliveryStore()

  return hits.map((hit) => ({
    hit,
    ...calculateItemPrice({
      hit,
      selectedPriceDayOffset,
      selectedRegion,
      isRapidPricingActive,
      getApplicablePromotions
    })
  }))
}